const preciseOperation = f => (a, b, decimalDigits) => {
  let decimalsA = countDecimals(a)
  let decimalsB = countDecimals(b)
  let calculatedDecimals = decimalsA > decimalsB ? decimalsA : decimalsB
  decimalDigits = decimalDigits || calculatedDecimals
  
  return Number((f(a, b)).toFixed(decimalDigits))
}
const countDecimals = function (i) {
  if(Math.floor(i.valueOf()) === i.valueOf()) return 0;
  return i.toString().split(".")[1].length || 0; 
}
const add  = (a, b) => a + b
const minus  = (a, b) => a - b
const multiply  = (a, b) => a * b
const divide  = (a, b) => a / b
export const preciseAdd = (a, b, decimalDigits) => preciseOperation(add)(a,b, decimalDigits)
export const preciseMinus = (a, b, decimalDigits) => preciseOperation(minus)(a,b, decimalDigits)
export const preciseMultiply = (a, b, decimalDigits) => preciseOperation(multiply)(a,b, decimalDigits)
export const preciseDivide = (a, b, decimalDigits) => preciseOperation(divide)(a,b, decimalDigits)